import { useQuery } from '@tanstack/react-query';
import { ExtractFnReturnType, QueryConfig } from '../../../lib/react-query';
import { fetchApi } from '../../../lib/fetchApi';
import { SurveysHeaderHistory } from '../types';
import { useTranslation } from 'react-i18next';

export const getHeaderHistory = async(): Promise<SurveysHeaderHistory> => {
  const response = await fetchApi.get('/surveys/headerHistory') as SurveysHeaderHistory;
  return response;
}

type QueryFnType = typeof getHeaderHistory;

type UseHeaderHistoryOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useHeaderHistory = ({ config = {} }: UseHeaderHistoryOptions = {}) => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    refetchOnMount: false,  // No hacer refetch al montar si no est� obsoleto
    refetchOnWindowFocus: false,  // No hacer refetch al enfocar la ventana
    queryKey: ["headerHistory", currentLanguage],
    queryFn: () => getHeaderHistory(),
  });
}